import { UIElement } from "./uiElement";

export class UILabel extends UIElement {

  protected readonly TITLE = "title";
  protected readonly FOR_ID = "forId";

  get title(): string { return this.getInternalValue<string>(this.TITLE); }
  setTitle(title: string): this { return this.setInternalValue(this.TITLE, title); }

  get forId(): number { return this.getInternalValue<number>(this.FOR_ID); }
  setForId(forId: number): this { return this.setInternalValue(this.FOR_ID, forId); }

}